import { render, staticRenderFns } from "./NewPage.vue?vue&type=template&id=395478ce&scoped=true&"
import script from "./NewPage.vue?vue&type=script&lang=js&"
export * from "./NewPage.vue?vue&type=script&lang=js&"
import style0 from "./NewPage.vue?vue&type=style&index=0&id=395478ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395478ce",
  null
  
)

export default component.exports